import { FAQS } from "../../data/content";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../ui/accordion";

export default function FAQ() {
  return (
    <section id="faq" data-testid="faq-section" className="relative py-28 md:py-40 px-6 md:px-10">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-14">
          <span className="font-mono-x text-primary text-xs tracking-[0.35em]">/ 11 — ANSWERS</span>
          <h2 className="mt-6 font-heading font-extrabold tracking-tighter text-4xl md:text-5xl">Frequently asked</h2>
        </div>
        <Accordion type="single" collapsible className="space-y-4">
          {FAQS.map((f, i) => (
            <AccordionItem key={i} value={`item-${i}`} data-testid={`faq-item-${i}`} className="glass rounded-2xl px-6 border-border">
              <AccordionTrigger className="text-left font-heading font-semibold text-lg hover:no-underline hover:text-primary">{f.q}</AccordionTrigger>
              <AccordionContent className="text-muted-foreground text-base">{f.a}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
